/**
 * OldDashboard — the legacy line-graph dashboard preserved verbatim from
 * the pre-2026-05-20 Home implementation. Kept renderable so Millard
 * Sprinkler can A/B against the new dashboard in prod via the toggle in
 * Home. Delete this file along with `dashboardVersion.ts` once the new
 * dashboard is fully rolled out.
 */

import * as React from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import LineGraph from "components/lineGraph";
import { Button } from "components/button";
import Onboarding from "./container/onboarding";
import Production from "./container/production";
import {
  fetchRequestByMonth,
  fetchNumberOfCustomer,
  fetchRequestByCategory,
} from "./api";
import { ChildGraphCon, ButtonCon } from "./style";

const buttonArray = ["week", "month", "year"];

export default function OldDashboard() {
  const { t } = useTranslation();
  const tBase = "views.home.index";
  const tr = (key: string) => t(`${tBase}.${key}`);
  const [view, setView] = React.useState("week");

  const requestByMonth = useQuery(
    ["requestByMonth", view],
    async () => await fetchRequestByMonth(view),
  );

  const numberOfCustomer = useQuery(
    ["numberOfCustomer", view],
    async () => await fetchNumberOfCustomer(view),
  );

  const requestByCategory = useQuery(
    ["requestByCategory", view],
    async () => await fetchRequestByCategory(view),
  );

  const populateRequestByCategory =
    requestByCategory.data &&
    requestByCategory.data.map((category: { link: any; counts: any }) => (
      <LineGraph
        key={category.link}
        data={category.counts}
        x={"day"}
        y="count"
        title={`${category.link} Requests`}
      />
    ));

  return (
    <div className="p-4 space-y-4">
      <Onboarding />
      <Production />
      <h1>{tr("Dashboard")}</h1>
      <ButtonCon selected={buttonArray.findIndex((button) => button === view)}>
        <Button onClick={() => setView("week")}>{tr("1w")}</Button>
        <Button onClick={() => setView("month")}>{tr("1m")}</Button>
        <Button onClick={() => setView("year")}>{tr("1y")}</Button>
      </ButtonCon>
      <LineGraph
        data={requestByMonth.data}
        x={"day"}
        y={"count"}
        title={tr("Requests")}
      />
      <ChildGraphCon>
        <LineGraph
          data={numberOfCustomer.data}
          x={"day"}
          y={"count"}
          title={tr("Customers")}
        />
        {populateRequestByCategory}
      </ChildGraphCon>
    </div>
  );
}
